const INITIAL_STATE = {
  errors: {},
  refundPayment: {}
}

const refundPayment = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'REFUND_PAYMENT':
    return { ...state, ...INITIAL_STATE, refundPayment: action.data }
  case 'REFUND_PAYMENT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default refundPayment;
